import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(4),
    width: "99.9%",
    height: "95%",
    borderRadius: 8,
    cursor: "pointer",
    boxShadow:
      "0px 4px 4px rgba(0, 0, 0, 0.05), 0px -4px 4px rgba(0, 0, 0, 0.05), 4px 0px 4px rgba(0, 0, 0, 0.05), -4px 0px 4px rgba(0, 0, 0, 0.05)",
    "& svg": {
      padding: theme.spacing(0),
    },
  },
  graphTitle: {
    fontSize: 18,
    fontWeight: 800,
    margin: theme.spacing(2, 0),
    paddingBottom: theme.spacing(2),
  },
  heading: {
    fontWeight: "400",
    fontSize: "18px",
    margin: theme.spacing(2, 0),
    paddingBottom: theme.spacing(2),
  },
}));

export default useStyles;
